export default "__VITE_ASSET__YopSY1Dp__"